import { render, staticRenderFns } from "./Korrespondenzliste.vue?vue&type=template&id=d16d060e"
import script from "./Korrespondenzliste.vue?vue&type=script&lang=js"
export * from "./Korrespondenzliste.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports